
























































































import {Component, Inject} from "vue-property-decorator";
import Api from "./Api";
import {BillingInfoLocation, BillingInfoTerminal} from "../../modules/models";
import LicenseTypePopup from "./LicenseTypePopup.vue";
import CompanyUserRequired from "../CompanyRequired";
import rd from "../../modules/vRoutedefs";
import InvoicingInfo from "@/components/location/InvoicingInfo.vue";

@Component({
    components: {
        "at-license-type-popup": LicenseTypePopup,
    }
})
export default class BillingPage extends CompanyUserRequired {
    @Inject()
    api!: Api;

    get priceInfoTo() {
        return {path: rd.docs.priceinfo.path};
    }

    loading = false;
    billingTerminals: BillingInfoTerminal[] = [];
    billingLocations: BillingInfoLocation[] = [];

    async loadBillingEntities() {
        try {
            this.loading = true;
            this.billingLocations = await this.api.activeBillingLocationsInfo(this.company.orgNum);
            this.billingTerminals = await this.api.activeBillingTerminalsInfo(this.company.orgNum);
        } finally {
            this.loading = false;
        }
    }

    get billingLocationsHasInvoiceRef() {
        return this.billingLocations.some((r) => r.invoiceRef != null);
    }
    get terminalsHasInvoiceRef() {
        return this.billingTerminals.some((r) => r.invoiceRef != null);
    }

    // true when showing dialog with info
    showExceptedBecauseTerminalInfo = false;

    locationPageTo(id: number) {
        return {name: rd.locations.location.name, params: {locationId: id}};
    }
    terminalPageTo(guid: string) {
        return {name: rd.terminals.terminal.name, params: {guid: guid}};
    }

    created() {
        this.loadBillingEntities();
    }
}
